import { useTypedSelector } from "hooks";
import { MenuItem, filters } from "consts/consumers";
import { FilterVariant, date } from "consts/filters";
import { selectIsConsumersLoading } from "features/consumers/selectors";
import { useWhiteListedConsumersActions } from "features/consumers/actions";
import { useConsumerContext } from "../../ConsumerProvider";

export default function useWhitelistedConsumersTable() {
    const isConsumersLoading = useTypedSelector(selectIsConsumersLoading(MenuItem.WhiteListed));

    const { selectionModel, setSelectionModel } = useConsumerContext();

    const {
        getConsumers,
        downloadCsv
    } = useWhiteListedConsumersActions();

    const whitelistedConsumers = filters.get(MenuItem.WhiteListed)!;

    const filterTypes = new Map<FilterVariant, string[]>([
        [FilterVariant.Text, whitelistedConsumers[FilterVariant.Text]!],
        [FilterVariant.DateRange, date],
        [FilterVariant.MultiOption, whitelistedConsumers[FilterVariant.MultiOption]!]
    ]);

    const isRowSelectable = () => !isConsumersLoading;

    return {
        isConsumersLoading,
        filterTypes,
        selectionModel,
        isRowSelectable,
        getConsumers,
        downloadCsv,
        setSelectionModel
    };
};
